import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import queryString from 'query-string';

import { AdminRecruiterSections } from './enums';
import { MembersPageType } from 'features/admin/member/enums';
import AdminMembersSection from 'features/admin/member/AdminMembersSection';
import useQueryMatch from 'hooks/useQueryMatch';

const DEFAULT_SECTION = AdminRecruiterSections.Recruiters;
const PAGE_SECTIONS = Object.values(AdminRecruiterSections);

export default function RecruitersPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const query = queryString.parse(location.search);
  const pageSectionMatch = useQueryMatch(PAGE_SECTIONS);

  useEffect(() => {
    if (!pageSectionMatch) {
      navigate(`${location.pathname}?section=${DEFAULT_SECTION}`, {
        replace: true,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageSectionMatch]);

  const getSection = () => {
    switch (query.section) {
      case AdminRecruiterSections.Recruiters:
      default:
        return <AdminMembersSection pageType={MembersPageType.Details} />;
    }
  };

  return <>{getSection()}</>;
}
